export function getToken() {
  const entry = document.cookie
    .split('; ')
    .find((row) => row.startsWith('_auth='));

  return entry ? entry.split('=')[1] : null;
}

export function authHeader() {
  const zeton = getToken();
  return zeton ? { Authorization: `Bearer ${zeton}` } : {};
}
